


export class BrowserAppEvaluationToolInfo {

  public version = '2024.8.26.1';

  constructor() {
  }

}
